import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import ListCollection from 'types/redux/ListCollection';

import Company from 'models/Company';

import { LIST_MARKUP } from 'consts/api';
import { fillPage } from 'utils/translations';

import { list as listCompanies } from 'requests/companies';

import Component from './component';
import { Props } from './types';

export async function getServerSideProps(context: GetServerSidePropsContext): Promise<GetServerSidePropsResult<Props>> {
    let companies: ListCollection<Company> = LIST_MARKUP;

    try {
        await Promise.all([
            listCompanies({ page: 1, perPage: 6 }),
        ]).then(responses => {
            companies = responses[0]?.partners;
        });
    } catch (error) {
        console.error(error);
    }

    let pageTranslations = JSON.parse(JSON.stringify(require('locales/pl/pages/companies')?.default));
    const fillValues = {};
    pageTranslations = fillPage(pageTranslations, null, fillValues);

    return {
        props: {
            pageTranslations,
            companies: JSON.parse(JSON.stringify(companies)),
        },
    };
}

export default Component;

